import { Scenes } from '../constants/game'
import { AUDIO } from '../constants/audio'
import { COPY } from '../constants/copy'
import { IAudioPlayerService } from '../services/AudioPlayerService/IAudioPlayerService'
import { IExecutor } from './IExecutor'
import { AudioQueueManager } from 'src/services/AudioQueueManagerService/AudioQueueManagerService'
import { ISpeechService } from 'src/services/SpeechService/ISpeechService'
import { isTvMode } from '../utils/tvMode'

// heifferopol.is lapsed; the cow's game lives on Vercel now.
const HEIFFEROPOLIS_URL = 'https://heifferopol.vercel.app/'

export class SplashScreenSceneExecutor extends IExecutor {
  private audioPlayer: IAudioPlayerService
  private setScene: (scene: Scenes) => void
  private audioQueueManager: AudioQueueManager
  private speech: ISpeechService
  private hasStarted = false
  private cowBusy = false

  constructor(
    audioPlayer: IAudioPlayerService,
    setScene: (scene: Scenes) => void,
    audioQueueManager: AudioQueueManager,
    speech: ISpeechService,
  ) {
    super()
    this.audioPlayer = audioPlayer
    this.setScene = setScene
    this.audioQueueManager = audioQueueManager
    this.speech = speech
  }

  public exec = async () => {
    console.log('🐄 SplashScreenSceneExecutor exec')
  }

  public handleTrolleyClick = () => {
    if (this.hasStarted) return
    this.hasStarted = true

    // Prime speech synthesis while we are still inside the user gesture —
    // iOS Safari refuses to ever speak otherwise.
    this.speech.unlock()

    this.audioQueueManager.enqueue(() =>
      this.audioPlayer.playSound(AUDIO.BeepBeep),
    )
    this.audioQueueManager.enqueue(async () => {
      this.setScene(Scenes.Intro)
    })
  }

  public handleCowClick = () => {
    if (this.hasStarted) return

    // Inside the Fire TV shell any navigation leaves the free game (and a
    // dead link becomes an "offline" error at the launcher). The cow just
    // moos about her own game instead.
    if (isTvMode()) {
      if (this.cowBusy) return
      this.cowBusy = true
      this.audioQueueManager.enqueue(() =>
        this.audioPlayer.playSound(AUDIO.BeepBeep),
      )
      this.audioQueueManager.enqueue(() => this.speech.speak(COPY.COW_ON_TV))
      this.audioQueueManager.enqueue(async () => {
        this.cowBusy = false
      })
      return
    }

    // New tab so the game the player already loaded is still here when
    // they come back. (An anchor click, not window.open: with noopener
    // window.open returns null even on success, so it cannot be checked.)
    const link = document.createElement('a')
    link.href = HEIFFEROPOLIS_URL
    link.target = '_blank'
    link.rel = 'noopener noreferrer'
    document.body.appendChild(link)
    link.click()
    link.remove()
  }
}
